<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'serialNo'
        label= '序列号'
        width= '220'>
      </el-table-column>
      <el-table-column
        prop= 'lineStatus'
        label= '在线状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.lineStatus===1">在线</el-button>
          <el-button type='info' size='small' v-if="scope.row.lineStatus===0">离线</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'otaVersion'
        label= '当前版本'
        width= '100'>
      </el-table-column>  
      <el-table-column
        prop= 'addTime'
        label= '添加时间'
        width= '160'>
      </el-table-column>     

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '160'>
        <template slot-scope='scope'>
          <el-button @click='otaUp(scope.row)' type='text' size='small' style="color: #209323">升级日志</el-button>
          <el-button @click='otaUp(scope.row)' type='text' size='small' style="color: #209323">版本升级</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="升级版本" :label-width="formLabelWidth" prop="version">
          <el-select v-model="form.version" placeholder="请选择">
            <el-option v-for="item in otaFiles" :key="item.version" :label="item.name" :value="item.version"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>    
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      deviceProjects: [],
      deviceModels: [],
      apiUrl: '',
      form: {
        deviceInstantiationSerialNo: null,
        deviceInstantiationId: null,
        updateVersion: null
      },
      rules: {
      },
      otaFiles: []
    }
  },
  created () {
    this.apiUrl = this.$global.apiUrl
    this.queryDeviceProjects()
    this.queryOtaFiles()
  },
  watch: {
  },
  methods: {
    queryOtaFiles () {
      let that = this
      requestService.get(`/deviceOta/listPage?current=1&pageSize=1024000`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.otaFiles = res.data.body.records
      })
    },
    otaUp (row) {
      this.form = {deviceInstantiationSerialNo: row.serialNo, deviceInstantiationId:row.id}
      this.dialogFormVisible = true;
    },
    query () {
      let that = this
      requestService.get(`/deviceInstantiation/listPageForAdmin?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        for(let item of that.tableData){
          for(let project of that.deviceProjects){
            if(project.id==item.deviceProjectId){
              item.deviceProjectName = project.name
              break;
            }
          }
        }
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          requestService.post('/deviceOtaRecord/add', that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    },
    queryDeviceProjects () {
      let that = this
      requestService.get(`/deviceProject/listPage?current=1&pageSize=1024000`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceProjects = res.data.body.records
        that.query()
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/deviceOtaRecord/Index.vue